const dataParser = (data) => {
  const tempData = data || {};
  if (typeof tempData === "object") {
    Object.keys(tempData).map((key) => {
      if (typeof tempData[key] === "object") {
        tempData[key] = dataParser(tempData[key]);
      } else {
        tempData[key] = typeChecker(tempData[key]);
      }
    });
  }
  return tempData;
};
export default dataParser;

function typeChecker(value) {
  if (value === "true") {
    return true;
  }
  if (value === "false") {
    return false;
  }
  return value;
}
